import React, {useState} from 'react'
import PropTypes from 'prop-types'

MultiInput.propTypes = {
    field: PropTypes.string,
    index: PropTypes.number,
    value: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool
}

function MultiInput(props) {
    const [inputValue, setInputValue] = useState('')
    const [isPaste, setIsPaste] = useState(false)

    function arrayUnique(array) {
        const a = array.concat()

        for (let i = 0; i < a.length; ++i) {
            for (let j = i + 1; j < a.length; ++j) {
                if (a[i] === a[j])
                    a.splice(j--, 1)
            }
        }

        return a
    }

    function _convertString(string) {
        const {regex, value_first} = props
        const newRegex = regex ? regex : /,\n|,|\s/
        const parsed = string.split(newRegex)
        let check = !!parsed && parsed.length > 0 && parsed.filter(item => item !== "")
        let combinedArray = [].concat(value_first)

        if (combinedArray.length === 0) {
            return check
        } else {
            return check.filter(x => !combinedArray.includes(x))
        }
    }

    function _checkString(string) {
        const {regex} = props
        const newRegex = regex ? new RegExp(regex.source, regex.flags + 'gi') : /,\n|,|\s/gi
        return newRegex.test(string)
    }

    function _onPasteInputFirst(e) {
        const value = e.clipboardData.getData('Text')
        setIsPaste(true)
        const {onChange, value_first, field, index} = props
        const input = _convertString(value, 'first')
        const newValue = arrayUnique(value_first.concat(input))
        
        if (typeof onChange === 'function') {
            onChange(field, index, newValue)
        }
    }

    function _handleChangeInputFirst(e) {
        const {value} = e.target
        setInputValue(value)
        const {onChange, value_first, field, index} = props
        const input = _convertString(value)
        const check = _checkString(value)
        
        if ((!!input && input.length > 0 && check) || (input.length === 0 && check)) {
            const newValue = arrayUnique(value_first.concat(input))
            console.log('new value: ', newValue)
            if (typeof onChange === 'function') {
                onChange(field, index, newValue)
                setInputValue('')
            }
        }
        
        if(isPaste) setInputValue('')
        setIsPaste(false)
    }

    function _onRemoveValueFirst(value) {
        const {onChange, value_first, field, index} = props
        const newArray = value_first.filter(item => item !== value)

        if (typeof onChange === 'function') {
            onChange(field, index, newArray)
        }
    }

    const { value_first, disabled} = props

    return (
        <div className={`SettingRulerInput ${disabled ? 'disabled' : ''}`} style={{width: 400}}>
            <div className='ListInput'>
                <div className="CustomSelect ant-input">
                    <div className="Selected">
                        {
                            !!value_first && value_first.length > 0 && value_first.map((item, index) => (
                                <span key={`allow-${index}`}>
                                    {item}
                                    <i
                                        className='icon-cross3 ml-1'
                                        onClick={() => _onRemoveValueFirst(item)}
                                    />
                                </span>
                            ))
                        }

                        <div className="Input">
                            <input
                                type="text"
                                value={inputValue}
                                name='allow'
                                onPaste={_onPasteInputFirst}
                                onChange={_handleChangeInputFirst}
                                disabled={disabled}
                            />
                        </div>
                    </div>
                </div>
                {/* <div className='input-tooltip'>
                    {`Nhập ${label.toLowerCase()} sau đó ấn${regexSource.includes('\\s') ? ' phím cách hoặc':''} dấu phẩy để thêm.`}
                </div> */}
            </div>
        </div>
    )
}

export default MultiInput
